import { render } from "./Referencias.vue?vue&type=template&id=8444be94&scoped=true"
import script from "./Referencias.vue?vue&type=script&lang=js"
export * from "./Referencias.vue?vue&type=script&lang=js"

import "./Referencias.vue?vue&type=style&index=0&id=8444be94&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Josue\\Documents\\IMSS\\CDI\\SITE\\frontrdsyuc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8444be94"]])

export default __exports__